<template>
    <v-container fluid>
      <div class="modal-padding">
        <v-row>
            <v-col cols="12" sm="12">
                <div class="center-name" v-html="data.message"></div>
            </v-col>          
        </v-row>
        <v-row>
            <v-col cols="12" sm="12">
              <div class="right-align yes-no-block">
                  <v-btn @click="onClose({status:false,action:'yes',...data})" class="right-btn cust-btn" color="primary">Yes</v-btn>   
                  <v-btn @click="onClose({status:false,action:'no',...data})" class="right-btn cust-btn no-btn" color="primary">No</v-btn>           
              </div>
            </v-col>
        </v-row>
      </div>
    </v-container>
</template>
<script>
export default {
 name: 'DeleteCenter',   
 props:['onClose','data'],
  data () {    
     return {
       
     }
  }  
}
</script>